export enum EdugameEnum {
    SingleQuestion = 0,
    Hangman = 1,
    EducallWizard = 2,
    HeroOfSpace = 3,
    FillInTheBlanks = 4,
    SortChampion = 5,
    WhoWantsToBeATolker = 6,
    WordPronunciation = 7
}